<lib-cdw-dialog
  toolbarTitle="Add platform admin"
  customWidth="480px"
  secondaryButtonText="Cancel"
  [primaryButtonText]="submitting ? 'Adding…' : 'Add admin'"
  [primaryButtonDisabled]="form.invalid || submitting"
  [secondaryButtonDisabled]="submitting"
  [hard]="submitting"
  buttonAlignment="justify-end"
  (primaryButtonClick)="submit()"
  (secondaryButtonClick)="cancel()"
  (dismissButtonClick)="cancel()"
>
  <form class="add-admin-form" [formGroup]="form" (ngSubmit)="submit()">
    <p class="add-admin-sub">
      They'll get console access on their next sign-in. Allowed domains:
      <strong>{{ allowedDomains.join(', ') }}</strong>.
    </p>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="email"
        label="Email"
        [placeholder]="emailPlaceholder"
        [required]="true"
        [hideRequiredMarker]="true"
        size="100%"
      ></lib-common-ui-components-text-input>
      <div
        class="field-error"
        *ngIf="emailControl.touched && emailControl.invalid"
      >
        <ng-container *ngIf="emailControl.errors?.['disallowedDomain']; else emailFormat">
          Domain not allowed here. Use: {{ allowedDomains.join(', ') }}.
        </ng-container>
        <ng-template #emailFormat>Enter a valid email address.</ng-template>
      </div>
    </div>

    <div class="field">
      <lib-common-ui-components-text-input
        formControlName="name"
        label="Full name"
        placeholder="Jane Doe"
        [required]="true"
        [hideRequiredMarker]="true"
        size="100%"
      ></lib-common-ui-components-text-input>
      <div
        class="field-error"
        *ngIf="nameControl.touched && nameControl.invalid"
      >
        A name is required.
      </div>
    </div>

    <div class="field">
      <lib-cdw-checkbox formControlName="isSuper">
        Super admin — can add and remove other console admins
      </lib-cdw-checkbox>
    </div>

    <div class="form-error" *ngIf="serverError">
      <lib-cdw-icon icon="error" size="20px"></lib-cdw-icon>
      <span>{{ serverError }}</span>
    </div>
  </form>
</lib-cdw-dialog>
